export class FilterOption {
    name: number;
    type: string;
    options:any;
    default: any;
    label: string;
    constructor(option?) {
        if (option) {
            this.name = option.name;
            this.type = option.type;
            this.options = option.options;
            this.default = option.default;
            this.label = option.label;
        }
    }
}
